import React from 'react'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import map from 'ramda/src/map'

import Typography from '../../../lib/typography'
import { parseFinancial } from '../../../lib/utils'

import { createTableCard } from '../../../components/project-profit-sheet/TableCard'
import IndicatorCost, * as IndicatorCostLayout from '../../../components/project-profit-sheet/IndicatorCost'

import { ppsSelector } from '../../../selectors'

import { determineColor, determineStatusColor } from '../model'

import { ABOVE_CURRENT_PRICE, MD } from '../constants'

const BaseCard = createTableCard(css`
  grid-template-columns: repeat(7, calc(100% / 7));
`)

const Card = {
  ...BaseCard,
  Container: styled(BaseCard.Container)`
    height: 70px;
    padding-bottom: 12px;
    align-items: end;

    ${IndicatorCostLayout.Root} {
      width: 95%;
      margin-left: 8px;
      grid-column: span 3;
    }
  `,
}

/**
 * @param {object} props
 * @param {object} props.profitData
 */
function ManDayContainer({ profitData }) {
  const data = map(parseFinancial, {
    forecast: profitData[`$man_day_forecast`],
    actual: profitData[`$man_day_actual`],
    remaining: profitData[`$man_day_remaining`],
    initial: profitData[`$man_day_initial_plan`],
    cr: profitData['$man_day_change_request_man_days'],
    gap: profitData[`$man_day_gap`],
  })

  const bars = [
    {
      value: data.actual,
      color: '#5cb85c',
      label: 'Actual MD',
      formatter: { full: MD },
    },
    {
      value: data.remaining,
      color: '#9be89b',
      label: 'Remaining MD',
      formatter: { full: MD },
    },
  ]

  const markers = [
    {
      value: data.initial,
      color: '#404040',
      type: 'solid',
      label: 'Approved Plan MD',
      formatter: { abbr: MD, full: MD },
      trigger: ABOVE_CURRENT_PRICE,
    },
  ]

  return (
    <Card.Root topic="Service Man-days Summary">
      <Card.Heading>
        <Typography.Data>Forecast MD</Typography.Data>
        <Typography.Data>Approved Plan MD</Typography.Data>
        <Typography.Data style={ { paddingLeft: 8 } }>Progress</Typography.Data>
        <div />
        <div />
        <Typography.Data>CR MD</Typography.Data>
        <Typography.Data title="Forecast - Approved Plan MD">
          Forecast - Approved Plan MD
        </Typography.Data>
      </Card.Heading>
      <Card.Container>
        <Typography.Data disc={ determineStatusColor(data) }>
          {data.forecast.toFixed(1)} MDs
        </Typography.Data>
        <Typography.Data disc="black" weight="normal">
          {data.initial.toFixed(1)} MDs
        </Typography.Data>
        <IndicatorCost threshold={ 0.05 } bars={ bars } markers={ markers } />
        <Typography.Data weight="normal">{data.cr.toFixed(1)} MDs</Typography.Data>
        <Typography.Data weight="normal" color={ determineColor(data.gap) }>
          {data.gap.toFixed(1)} MDs
        </Typography.Data>
      </Card.Container>
    </Card.Root>
  )
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
})

export default connect(mapStateToProps)(ManDayContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/ManDayContainer.js